module.exports = __webpack_public_path__ + "/assets/suggested.png";


/*****************
 ** WEBPACK FOOTER
 ** ../src/dash/front/styles/images/suggested.png
 ** module id = 1065
 ** module chunks = 0
 **/